import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartnerSimilarPartnerSummaryFieldComponent} from './partner-similar-partner-summary-field.component';
import {SummaryFieldModule} from '../../../../../core/component/summary-field/summary-field.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {
    PartnerSimilarPartnerViewDialogModule
} from '../partner-similar-partner-view-dialog/partner-similar-partner-view-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        SummaryFieldModule,
        MatTooltipModule,
        MatIconModule,
        PartnerSimilarPartnerViewDialogModule,
    ],
    declarations: [
        PartnerSimilarPartnerSummaryFieldComponent,
    ],
    exports: [
        PartnerSimilarPartnerSummaryFieldComponent
    ],
})
export class PartnerSimilarPartnerSummaryModule{}
